export enum DealStatusEnum {
    New = 1,
    Sent = 2,
    Opened = 3,
    Signed = 4,
    Canceled = 5
}

	


// WEBPACK FOOTER //
// ./src/app/_enums/deal-status.enum.ts